import { atom } from "recoil";

export const activeActivity = atom({
  key: "activeActivity",
  default: {
    active: false,
    data: undefined,
  },
});
